import type { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import { getCorporates } from '@/api/corporate/corporate'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_CORPORATE_INFO]: async (
    { commit, dispatch },
    recipientId: number
  ): Promise<void> => {
    const infoItem = await getCorporates(recipientId)
    if (infoItem) {
      infoItem.chem_value_contract_flag_str =
        infoItem?.chem_value_contract_flag == '1' ? true : false
      infoItem.ocr_contract_flag_boolean =
        infoItem?.ocr_contract_flag == '1' ? true : false
      infoItem.ocr_read_target_flag2_boolean =
        infoItem?.ocr_read_target_flag2 == '1' ? true : false
      infoItem.ocr_read_target_flag3_boolean =
        infoItem?.ocr_read_target_flag3 == '1' ? true : false
      infoItem.ocr_read_target_flag9_boolean =
        infoItem?.ocr_read_target_flag9 == '1' ? true : false
      infoItem.ocr_read_target_flag14_boolean =
        infoItem?.ocr_read_target_flag14 == '1' ? true : false
      infoItem.ocr_read_target_flag15_boolean =
        infoItem?.ocr_read_target_flag15 == '1' ? true : false
      infoItem.mfa_contract_flag_boolean =
        infoItem?.mfa_contract_flag == '1' ? true : false
    }
    commit(actionTypes.SET_CORPORATE_INFO, infoItem)
  },
  [actionTypes.SET_CORPORATE_PAGE_STATUS]: ({ commit, state }, number: number): void => {
    commit(actionTypes.SET_CORPORATE_PAGE_STATUS, number)
  },
  [actionTypes.SET_CORPORATE_ID]: ({ commit, state }, number: number): void => {
    commit(actionTypes.SET_CORPORATE_ID, number)
  },
}

export default actions
